import type { FC, PropsWithChildren } from 'react';

import { cn } from '@/utils/tailwind';
import { useRouteMatcher } from '@/utils/url';

import Constants from '@/constants';

const MainContent: FC<PropsWithChildren> = ({ children }) => {
  const routeMatches = useRouteMatcher();

  const isDocument = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.DocumentPath,
  );

  const isPlansTabs =
    routeMatches.includes(Constants.ROUTE_PATH_GROUPS.TrainingPath) &&
    routeMatches.length <= 2;

  const isReportsTabs =
    routeMatches.includes(Constants.ROUTE_PATH_GROUPS.ReportsPath) &&
    routeMatches.length <= 2;

  return (
    <div
      className={cn('mx-auto flex h-auto w-full grow flex-col', {
        'px-0 text-center': isPlansTabs || isReportsTabs,
        'bg-document-background-gray': isDocument,
      })}
    >
      {children}
    </div>
  );
};

export default MainContent;
